import { IssueFieldValue } from '@issuemanager/constants';
import { useMemo } from 'react';

export interface UseViewIssueFieldStateParams {
  formFieldNames: readonly IssueFieldValue[];
  readableFields?: readonly IssueFieldValue[] | null;
}

export type ViewIssueFieldState = Record<IssueFieldValue, { visible: boolean }>;

export const useViewIssueFieldState = ({
  formFieldNames,
  readableFields,
}: UseViewIssueFieldStateParams): ViewIssueFieldState =>
  useMemo(() => {
    const readableFieldsSet = new Set(readableFields ?? []);
    const states = {} as ViewIssueFieldState;

    for (const formFieldName of formFieldNames) {
      states[formFieldName] = { visible: readableFieldsSet.has(formFieldName) };
    }

    return states;
  }, [readableFields, formFieldNames]);
